import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var ShieldOff = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "shield-off",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m8.8087 3.1966 2.6295-.986c.2079-.078.3118-.117.4188-.1324a.9995.9995 0 0 1 .286 0c.107.0154.2109.0544.4188.1323l5.3618 2.0107c.7486.2808 1.1229.4211 1.3987.6642.2437.2148.4314.4856.5469.7892C20 6.0182 20 6.418 20 7.2175v4.7824c0 .7203-.1153 1.4118-.3182 2.0709m-2.0599 3.5547c-1.6857 1.9604-3.834 3.3533-4.9223 3.9883-.2224.1298-.3336.1947-.4898.2282-.1213.026-.2982.026-.4194 0-.1563-.0335-.267-.0981-.4884-.2273C9.354 20.4783 4 16.9083 4 11.9999V5.7762c0-.467.2897-.885.7269-1.049M3 3l18 18"
    })
  }));
};
export default ShieldOff;